import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { SOURCE_STATUS } from "../../../features/builder.constants";
import { TRIGGER_TYPES } from "./trigger.constants";

// Advanced filter of the Trigger list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_library/trigger/controller.js, the whitelist get-all filters on.
export const triggerFilterFields = [
  { key: "trigger_type", label: "Type", type: "enum", group: "Details", options: TRIGGER_TYPES.map(({ value, label }) => ({ value, label })) },
  { key: "status", label: "Lifecycle", type: "enum", group: "Details", options: Object.entries(SOURCE_STATUS).map(([value, meta]) => ({ value, label: meta.label })) },
  { key: "source_fid", label: "Source", type: "select", group: "Details", optionsKey: "sources", optionLabel: "label", optionValue: "id" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
